import { gql, useMutation } from "@apollo/client";
import { ConfirmationDialog } from "../../components/dialogs/confirmation-dialog";
import { FormattedMessage, useIntl } from "react-intl";
import React, { useState } from "react";
import { showErrorToast, showSuccessToast } from "../../toast/toast-service";
import { TextField } from "@mui/material";
import styled from "@emotion/styled";
import { useHistory } from "react-router-dom";
import { getGraphQLErrorMessage } from "../../helpers/network-helpers";


export const DELETE_USER_START = gql`
  mutation DeleteUserStartMutation {
    deleteUserStart
  }
`;

export const DeleteProfileDialog = ({ isOpen, toggle }) => {
  const [deleteUserStart] = useMutation(DELETE_USER_START, {
    onCompleted: () => {
      showSuccessToast(
        <FormattedMessage id={"edit-user-data.delete-account.dialog.success"} />
      );
      toggle();
    },
    onError: (err) => {
      showErrorToast(getGraphQLErrorMessage(err));
    },
  });


  return (
    <ConfirmationDialog
      title={<FormattedMessage id="edit-user-data.delete-account.dialog.title" />}
      content={
        <>
          <FormattedMessage id="edit-user-data.delete-account.dialog.description" />
          
        </>
      }
      isOpen={isOpen}
      toggle={toggle}
      action={deleteUserStart}
    />
  );
};

const InputTextField = styled(TextField)`
  && {
    margin-top: 10px;
    font-size: 10px;
    width: 100%;
  }
`;
